const sleep = msec =>
  new Promise(resolve => setTimeout(resolve, msec));

const searchShippingDayElement = async () => {
  for (let i = 0; i < 50; i++) {
    const shippingDayElement = document.querySelector('.delivery-container');
    if (shippingDayElement) {
      return shippingDayElement;
    }
    await sleep(100);
  }
  return null;
};

const searchVariantNameElement = async () => {
  for (let i = 0; i < 50; i++) {
    const shippingDayElement = document.querySelector('.product-item-meta__property-list span');
    if (shippingDayElement) {
      return shippingDayElement;
    }
    await sleep(100);
  }
  return null;
}

const isAnyGiftEnabled = fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const isGiftEnabledItemInCart = cart.items.some(item =>
          item.properties &&
          'ギフト購入' in item.properties &&
          item.properties['ギフト購入'] === '有効'
        );

        return isGiftEnabledItemInCart;
      })
      .catch(error => {
        console.log(`cart.js 読み込み失敗 ${error.message}`);
      });

searchShippingDayElement().then(shippingDayElement => {
  if (shippingDayElement && isAnyGiftEnabled) {
    shippingDayElement.style.display = 'none';
  }
});

searchVariantNameElement().then(shippingDayElement => {
  if (shippingDayElement && isAnyGiftEnabled) {
    shippingDayElement.style.display = 'none';
  }
});